import React from "react";
import OpcionDefecto from "../../../../../Common/Components/OpcionDefecto";
import CheckDefecto from "../../../../../Common/Components/CheckDefecto";
import ExpHelper from '../../../../../Common/Helpers/ExpHelper';

const Distribucion = ({ data, selectCheckBox, selectCombo }) => {
    const { GET_CODIGO_DISTRIBUCION, GET_PARAMETRO_GENERAL } = data;
    const acentoLetraOminuscula = ExpHelper.ConvertirCaracter("o");

    if (GET_PARAMETRO_GENERAL == null || GET_PARAMETRO_GENERAL == undefined) {
        return null;
    }

    if (GET_PARAMETRO_GENERAL.SINOCODIGODISTRIBUCION == true) {
        let arrayAux = [];

        if (GET_CODIGO_DISTRIBUCION.filter(d => d.Checked).length > 0) {
            arrayAux = GET_CODIGO_DISTRIBUCION.filter(d => d.Checked);
        }

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12 top-separator-xxs">
                    <label className="label-primary">{"Distribuci" + acentoLetraOminuscula + "n"}</label>
                </div>

                <div className="col-xs-12">
                    <CheckDefecto
                        nombre={"Utiliza C" + acentoLetraOminuscula + "digos de Distribuci" + acentoLetraOminuscula + "n"}
                        check={data.UtilizaCodigoDistribucion}
                        referencia={"UTCODIS"}
                        selectCheckBox={(event) => selectCheckBox("UtilizaCodigoDistribucion", event.target.checked)}
                    />
                </div>
                {data.UtilizaCodigoDistribucion && <div className="col-xs-12 left-separator-xs top-separator-xxs">
                    {GET_CODIGO_DISTRIBUCION.map( ( item ) => {
                        const referencia = `GCD-${item.Id}`;
                            
                        return (
                           ((item.administradoraId== 1 && item.Activo) || item.noDisponible )&& <CheckDefecto
                                key={item.Id}
                                nombre={item.Descripcion}
                                check={item.Checked}
                                activo={item.Activo}
                                referencia={referencia}
                                selectCheckBox={(event) => {
                                    if ( data.UtilizaCodigoDistribucion ) {
                                        selectCheckBox( "GET_CODIGO_DISTRIBUCION", item.Id, event.target.checked );
                                    }
                                }}
                            />
                        )
                    } )}
                </div>}
                <div className="col-xs-12">
                    {( !data.ERROR_PRODUCT.seleccionoCodigoDistribucion && arrayAux.length===0)
                        && <label className="error">{"Debe seleccionar al menos una distribuci" + acentoLetraOminuscula + "n."}</label>}
                </div>
                <div className="col-xs-12">
                    {data.UtilizaCodigoDistribucion &&<OpcionDefecto
                        selecciono={arrayAux.length}
                        infoData={arrayAux}
                        referencia={"CodigoDistribucionDefaultId"}
                        valorCombo={data.CodigoDistribucionDefaultId}
                        valorChecked={data.CodigoDistribucionDefaultInterfaz}
                        selectCombo={(value) => selectCombo("CodigoDistribucionDefaultId", value)}
                        selectCheckBox={(value) => selectCheckBox("CodigoDistribucionDefaultInterfaz", value)}
                    />}
                   
                </div>
            </div>
        );
    } else {
        return null;
    }
}

export default Distribucion;